.hero {
    margin-top: var(--hero-margin-top);
}

.heroImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: var(--hero-position, 50% 50%);
    overflow: hidden;
}

.heroOverlay {
    opacity: 0.15;
    background-color: black;
}

.heroContent {
    background-color: rgba(60, 174, 176, 0.72)
}

.heroContentText {
    color: #FFFFFF;
    font-weight: 700;
    line-height: 1.1em;
    letter-spacing: 0.5px;
}

.pageHeadingWrapper {
    z-index: 2;
    padding-bottom: 59px;
}

.pageHeadingContainer {
    width: 100%;
}

.pageHeading {
    overflow-wrap: normal;
    word-break: normal;
    hyphens: none;
    color: white;
    display: block;
    box-sizing: border-box;
    width: max-content;
    max-width: calc(100% - 40px);
    margin: 0 auto;
    padding: 0 25px;
    background-color: #FFA489;
    font-size: clamp(28px, 8.75vw, 35px);
    line-height: 1.1;
    letter-spacing: 0.5px;
    text-align: center;
}

@media (min-width: 769px) {
    .pageHeading {
        font-size: 50px;
        max-width: min(1160px, calc(100% - 160px));
    }
}

@media (min-width: 981px) {
    .pageHeadingWrapper {
        padding-bottom: 100px;
    }

    .pageHeading {
        font-size: 90px;
    }
}

@media (max-width: 480px) {
    .hero.fullImageOnMobile {
        height: auto;
        grid-template-columns: 100%;
        grid-template-rows: auto auto;
        /* Clear the fixed navigation instead of overlapping the top of the photo. */
        margin-top: 5px;
    }

    .fullImageOnMobile > .heroImage,
    .fullImageOnMobile > .heroOverlay {
        grid-column: 1;
        grid-row: 1;
    }

    .fullImageOnMobile > .heroImage {
        height: auto;
        object-fit: contain;
    }

    .fullImageOnMobile > .pageHeadingWrapper {
        grid-column: 1;
        grid-row: 2;
        padding: 16px 0 20px;
    }

    .heroImage {
        object-position: var(--hero-phone-position, var(--hero-position));
    }

    .pageHeadingWrapper {
        padding-bottom: 79px;
    }
}

@media (max-width: 480px) and (max-height: 600px) {
    .fullImageOnMobile .pageHeadingWrapper {
        padding: 8px 0 16px;
    }

    .fullImageOnMobile .pageHeading {
        font-size: 28px;
    }
}
